<template>
  <div class="lp-page blog-page">
    <Navbar />

    <!-- Hero -->
    <section class="lp-hero">
      <div class="lp-container">
        <span class="lp-eyebrow">{{ $t('blog.heroLabel') }}</span>
        <h1 class="lp-title">{{ $t('blog.heroTitle') }}</h1>
        <p class="lp-lead">{{ $t('blog.heroSubtitle') }}</p>
      </div>
    </section>

    <!-- Posts -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-grid lp-grid-3">
          <article class="blog-card lp-card reveal-item" v-for="(p, i) in posts" :key="i">
            <div class="blog-image" :class="'g' + ((i % 6) + 1)">
              <span class="blog-category">{{ $t(`blog.post${i + 1}.category`) }}</span>
            </div>
            <div class="blog-body">
              <div class="blog-meta">
                <span>{{ $t(`blog.post${i + 1}.date`) }}</span>
                <span>{{ p.read }} {{ $t('blog.minRead') }}</span>
              </div>
              <h3 class="lp-h3">{{ $t(`blog.post${i + 1}.title`) }}</h3>
              <p class="lp-text">{{ $t(`blog.post${i + 1}.excerpt`) }}</p>
              <a href="#" class="read-more">{{ $t('blog.readMore') }} <font-awesome-icon icon="fa-solid fa-arrow-right" /></a>
            </div>
          </article>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="lp-section">
      <div class="lp-container">
        <div class="lp-cta">
          <h2>{{ $t('blog.ctaTitle') }}</h2>
          <p>{{ $t('blog.ctaSubtitle') }}</p>
          <div class="cta-buttons">
            <a href="/register" class="lp-btn lp-btn-primary">{{ $t('blog.startTrial') }}</a>
            <a href="/contact" class="lp-btn lp-btn-secondary cta-secondary">{{ $t('blog.contactUs') }}</a>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Navbar from '../components/Navbar.vue';
import Footer from '../components/Footer.vue';
import { useReveal } from '../composables/useReveal';

const posts = [
  { read: 5 }, { read: 7 }, { read: 10 }, { read: 8 }, { read: 6 }, { read: 5 },
];

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'instant' });
});

useReveal();
</script>

<style scoped>
.blog-card { padding: 0; overflow: hidden; display: flex; flex-direction: column; }
.blog-image { height: 150px; position: relative; display: flex; align-items: flex-end; padding: 16px; }
.blog-image.g1 { background: linear-gradient(150deg, #5aa2ff, #2b82f0); }
.blog-image.g2 { background: linear-gradient(150deg, #34d399, #10b981); }
.blog-image.g3 { background: linear-gradient(150deg, #a78bfa, #7c5cff); }
.blog-image.g4 { background: linear-gradient(150deg, #fbbf24, #f59e0b); }
.blog-image.g5 { background: linear-gradient(150deg, #22d3ee, #06b6d4); }
.blog-image.g6 { background: linear-gradient(150deg, #f472b6, #ec4899); }
.blog-category { background: rgba(255,255,255,0.92); color: var(--ink); font-size: 11.5px; font-weight: 700; padding: 5px 12px; border-radius: var(--pill); letter-spacing: 0.02em; }
.blog-body { padding: 24px 26px 26px; display: flex; flex-direction: column; flex: 1; }
.blog-meta { display: flex; gap: 14px; font-size: 12.5px; color: var(--muted); margin-bottom: 10px; }
.blog-card .lp-h3 { font-size: 19px; margin-bottom: 8px; line-height: 1.25; }
.blog-card .lp-text { flex: 1; margin-bottom: 16px; font-size: 14.5px; }
.read-more { display: inline-flex; align-items: center; gap: 8px; color: var(--violet); font-weight: 600; font-size: 14px; transition: gap 0.2s ease; }
.blog-card:hover .read-more { gap: 12px; }

.cta-buttons { display: inline-flex; gap: 14px; flex-wrap: wrap; justify-content: center; }
.cta-secondary { background: rgba(255,255,255,0.1); color: #fff; border-color: rgba(255,255,255,0.25); }
.cta-secondary:hover { background: rgba(255,255,255,0.18); color: #fff; border-color: rgba(255,255,255,0.4); }
</style>
